import axios from "axios";


export class BarsService{
    static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND}`;

    static getALLBars() {
        let dataURL = `${this.serverURL}/bars`;
        console.log('dataURL.usuario');
         console.log(dataURL);
            return axios.get(dataURL);
           
    }
    
    static getBar(barId){
        let dataURL = `${this.serverURL}/bar/${barId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static getBarsVSL_Id(vslId){
        let dataURL = `${this.serverURL}/barVSl/${vslId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static createBar(bar){
        let dataURL = `${this.serverURL}/bar/`;
        console.log('dataURL.bar');
        console.log(dataURL,bar);
        return axios.post(dataURL,bar);
    }
       

    static updateBar(bar, vslId){
        let dataURL = `${this.serverURL}/bar/${vslId}`;
        return axios.put(dataURL, bar)
    }

    static deleteBar(controlId){
        let dataURL = `${this.serverURL}/bar/${controlId}`;
        return axios.delete(dataURL);
    }

    
       


}